import {TelephonePassengerProperties } from "./BookingPassengerTicketIssuanceProperties";
import { PassengerFares } from "./FlightSearchResponseProperties";


export class ONEGAutoModifyBookingDate {
  modifyDate: string;
  pnr: string;
  supplierPricingSolution: string;
  removeDateAuto: boolean;
  updateDateAuto: boolean;
  bookingId: number;
 
}
export class bookingInfoForONEG {
  bookingId: number;
  supplierPricingSolution: any;
  pnr: string;
  error: string;
  success: boolean;
  passengerFares: PassengerFares[];
  bookingPassengerInfoProperties: bookingPassengerInfoModifyForONEG[];
}

export class bookingPassengerInfoModifyForONEG {
  passengerId: number;
  firstName: string;
  lastName: string;
  selectToModify: boolean = false;
  telephoneCheck: boolean = false;
  travelDocumentCheck: boolean = false;
  loyaltyPointsChecked: boolean = false;
  emailCheck: boolean = false;
  telephoneOneGProperties: telephoneOneGProperties;
  travelDocumentOneGProperties: travelDocumentOneGProperties;
  customerLoyaltyPointsOneGProperties: customerLoyaltyPointsOneGProperties;
  emailOneGProperties: emailOneGProperties;
}

export class customerLoyaltyPointsOneGProperties {
  id: number;
  loyaltyPoints: string;
  
  isDeleted: boolean;
  addAble: boolean;
  modifyAble: boolean;
  deleteAble: boolean;
}

export class telephoneOneGProperties {
  id: number;
  telephone: TelephonePassengerProperties[];
  
  addAble: boolean;
  modifyAble: boolean;
  deleteAble: boolean;
}

export class travelDocumentOneGProperties {
  id: number;
  travelerDocument: oneGTravelDocument;

  addAble: boolean;
  modifyAble: boolean;
  deleteAble: boolean;
}

export class oneGTravelDocument {
  id: number;
  passportNumber: string;
  passportExpiryDate: Date;
  passportIssuanceDate: Date;
  issuanceCountry: string;
  gender: string;
  nationality: string;
  birthDate: Date;
  isDeleted: boolean;
}

export class emailOneGProperties {
  id: number;
  emailList: emailOneGUpdate[];

  addAble: boolean;
  modifyAble: boolean;
  deleteAble: boolean;
}

export class emailOneGUpdate {
  id: number;
  email: string;
  isDeleted: boolean;
}

export class ExchangeEligibility {
  exchangeable: string;
  passengerList: PassengerExchangePenalty[];
  currencyRate: number;
}

export class PassengerExchangePenalty {
  minimumPenaltyChange: number;
  maximumPenaltyChange: number;
  penaltyCancel: number;
  currencyCode: string;
  refundable: boolean;
  passengerName: string;
}

